<template>
  <div id="about" style="padding: 5%">
    
    <div id="bvsp">
      <!-- <img src="/img/bvsp.jpg" alt="">
      <h2>{{ translate('inspired-by-bvsp') }}</h2> -->
      <!-- <p> {{ translate('dedicated-to-bvsp') }}</p> -->
      <p> {{ translate('motivation') }}</p>
    </div>

    <div id="my-portfolio-link">
      <a href="https://adriel-portf.web.app" target="_blank">
        {{ translate('see-my-portfolio') }}
      </a>
    </div>

    <hr>
    <br>
    <div>
      {{ translate('info') }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <a href="https://www.facebook.com/adriel.werlichtigreoliveira" target="_blank" v-on="on">
            <img :src="getIcon('facebook')" alt="face-icon" style="width: 1.5rem;">
          </a>
        </template>
        <span>
          facebook
        </span>
      </v-tooltip>
      ||
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <a href="https://www.linkedin.com/in/adriel-werlich-61430428/" target="_blank" v-on="on">
            <img :src="getIcon('linkedin')" alt="linkedin-icon" style="width: 1.5rem;">
          </a>
        </template>
        <span>
          linkedin
        </span>
      </v-tooltip>
      <!-- ||
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <a href="https://www.instagram.com/werlichadriel/" target="_blank" v-on="on">
            <img :src="getIcon('instagram')" alt="instagram-icon" style="width: 1.5rem;">
          </a>
        </template>
        <span>
          instagram
        </span>
      </v-tooltip> -->
      ||
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <a href="https://twitter.com/werlich_adriel" target="_blank" v-on="on">
            <img :src="getIcon('twitter')" alt="twitter-icon" style="width: 1.5rem;">
          </a>
        </template>
        <span>
          twitter
        </span>
      </v-tooltip>
      
    </div>
    <br>
    <hr>

    <div id="donate">
      <h4> {{ translate('donate-to-support') }} </h4>
      <p>Paypal</p>
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
        <input type="hidden" name="cmd" value="_donations" />
        <input type="hidden" name="business" value="PRA2VJWL3QCB6" />
        <input type="hidden" name="currency_code" :value="language === 'pt' ? 'BRL' : 'USD'" />
        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit"
          title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
        <img alt="" border="0" src="https://www.paypal.com/en_BR/i/scr/pixel.gif" width="1" height="1" />
      </form>
    </div>

    <br>

    <div>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a
        href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>

    <div> {{ translate('made-with') }}</div>

  </div>
</template>

<script>
  import icons from '../assets/base64icons.json'
  import { eventBus } from '../main.js'
  import mixins from '../assets/mixins.js'

  export default {
    name: 'about',
    mixins: [mixins],
    mounted() {
      
      // // // this.$route.params.lang ? this.lang = this.$route.params.lang : null
      eventBus.$on('updateLanguage', this.setLang)
      
    },
    computed: {
     /* language() {
        if (this.lang) {
          return this.lang
        } else {
          this.checkLanguage()
        }
        return this.lang */
    },
    
    data() {
      return {
        lang: null,
      }
    },

    methods: {
      setLang(l) {
        this.lang = l 
      },

      getIcon(type) {
        return icons[type]
      },

      translate(section) {

        switch (section) {
          
          case 'motivation':
            if (this.language === 'pt')
              return 'Apenas aprendendo. Nenhuma pretensão de assumir posição de sabixão, poderoso chefão, religionismo pretencioso. Como diria um grande mestre sobre a necessidade de realizar a desprogramação que a sociedade impõe na forma de crenças religiosas, sociais e assim por diante. Existem muitos canalhas que se apossam dos sistemas religiosos pra promover seus próprios interesses egóicos e explorar outros. Apenas sociedades de hipócritas. Sempre tem lugar pra mais um, certo?'
            else
              return 'Just learning. No pretense of assuming the position of a savant, godfather, pretentious religionism. As a great teacher would say about the need to carry out the deprogramming that society imposes in the form of religious and social beliefs and so on. There are many scoundrels who take over religious systems to further their own selfish interests and exploit others. Just societies of hypocrits. There\'s always room for one more, right?'

          case 'see-my-portfolio':
            if (this.language === 'pt')
              return 'Se você estiver interessado em meus serviços profissionais clique aqui para ver meu portfolio!'
            else
              return 'If got interested in my professional services click here to see my personal portfolio!'

          case 'donate-to-support':
            if (this.language === 'pt')
              return 'Se quiser ajudar esse trabalho de disseminação do conhecimento védico, por favor, dê sua contribuição via'
            else
              return 'If you can, suppport this work of spreading the vedic knowledge by donating through'

          case 'info':
            if (this.language === 'pt')
              return 'Desenvolvido com muito 💖💖💖. Apesar de que sempre tem algum invejoso que ao invés de valorizar o esforço apenas enfatiza algum defeito, esses são os invejosos. - Entre em contato via Mídia Social -'
            else
              return 'Created with lots of 💖💖💖. Although there are always some envious people who, instead of valuing the effort, only emphasize some defect, these are the envious ones. - Get in touch via Social Media - '

          // case 'inspired-by-bvsp':
          //   if (this.language === 'pt')
          //     return 'Inspirado por Sua Divina Graça BhaktiVedanta Swami Prabhupada'
          //   else
          //     return 'Inspired by His Divine Grace BhaktiVedanta Swami Prabhupada'

          // case 'dedicated-to-bvsp':
          //   if (this.language === 'pt')
          //     return 'Como oferenda de serviço ao fundador do movimento Hare Krishna, sem ele eu não teria tido acesso ao conhecimento atemporal da Bhagavad-gita a canção entoada pelo Senhor Supremo Bhagavan Sri Krishna. \n Esse projeto ainda está em desenvolvimento. Se você encontrar algum bug, defeito, problema no carregamento das páginas, por favor, ajude o avanço da detecção e corrreção de falhas informando na seção de comentários, pelo email adrielwerlich@gmail.com ou entrando em contato via mídia social'
          //   else
          //     return 'As a offer of service to the founder of the Hare Krishna movement, withouth whow I wouldn´t have had access to the atemporal wisdow of the Bhagavad-gita, the music sung by the Supreme Lord Bhagavan Sri Krishna. \n This project is ongoing. If by any chance you find out any bug, error, or defect during page loads, please, help advancing flaw detection and correction by informing in the comments section, through adrielwerlich@gmail.com or by contacting through social media'
          
          case 'made-with':
            if (this.language === 'pt')
              return 'Feito com Vue.js, MaterialDesign e Airtable'
            else
              return 'Made with Vue.js, MaterialDesign and Airtable'
          case '':
            if (this.language === 'pt')
              return ''
            else
              return ''
          case '':
            if (this.language === 'pt')
              return ''
            else
              return ''
          case '':
            if (this.language === 'pt')
              return ''
            else
              return ''

          default:
            break;
        }
      },

    }
  }
</script>

<style>
  @media screen and (max-width: 768px) {

    #about {
      margin: 4% auto;
    }

  }
</style>